import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, useBreakpointValue } from '@chakra-ui/react';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Navbar/Sidebar';
import Dashboard from './Dashboard';
import Staff from './Staff';
import Technicians from './Technician/Technicians';
import Complaints from './Complaints';
import LiveTracking from './Technician/LiveTracking';
import TechnicianDetail from './Technician/TechnicianDetail';
import Inventory from './Inventory';
import Sales from './Sales/SalesDashboard';
import EnquiryForm from './Sales/EnquiryForm';
import QuotationForm from './Sales/QuotationForm';
import ProformaInvoiceForm from './Sales/ProformaInvoiceForm';

const SIDEBAR_W = '260px';

const Main = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isDesktop = useBreakpointValue({ base: false, md: true });

  return (
    <Box minH="100vh" bg="slate.50">
      <Box position="fixed" top={0} left={0} right={0} zIndex="sticky">
        <Navbar onMenuClick={() => setSidebarOpen((prev) => !prev)} />
      </Box>

      <Box display="flex" pt="64px" minH="100vh">
        {isDesktop ? (
          <Box
            position="fixed"
            left={0}
            top="64px"
            w={SIDEBAR_W}
            h="calc(100vh - 64px)"
            zIndex="docked"
          >
            <Sidebar />
          </Box>
        ) : (
          <>
            {sidebarOpen && (
              <Box
                position="fixed"
                top="64px"
                left={0}
                right={0}
                bottom={0}
                bg="blackAlpha.500"
                zIndex="overlay"
                onClick={() => setSidebarOpen(false)}
              />
            )}
            <Box
              position="fixed"
              top="64px"
              left={sidebarOpen ? 0 : `-${SIDEBAR_W}`}
              w={SIDEBAR_W}
              h="calc(100vh - 64px)"
              zIndex="modal"
              transition="left 0.25s ease"
              boxShadow="card"
            >
              <Sidebar onClose={() => setSidebarOpen(false)} />
            </Box>
          </>
        )}

        <Box
          flex={1}
          ml={{ base: 0, md: SIDEBAR_W }}
          px={{ base: 4, md: 8 }}
          py={6}
          minH="calc(100vh - 64px)"
          overflowY="auto"
          bgGradient="linear(180deg, slate.50 0%, brand.50 120%)"
        >
          <Box maxW="1440px" mx="auto">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/staff" element={<Staff />} />
              <Route path="/technicians/technician-list" element={<Technicians />} />
              <Route path="/technicians/live-tracking" element={<LiveTracking />} />
              <Route path="/technicians/:id" element={<TechnicianDetail />} />
              <Route path="/complaints" element={<Complaints />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/sales/enquiry" element={<EnquiryForm />} />
              <Route path="/sales/quotation" element={<QuotationForm />} />
              <Route path="/sales/proforma-invoice" element={<ProformaInvoiceForm />} />
              <Route path="*" element={<Box p={8} textAlign="center" color="slate.500">Page not found</Box>} />
            </Routes>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Main;
